import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeToast } from '../../../actions/global/toasts';
import type { RootState } from '../../../store/app';
import ToastsList from './ToastsList';

const ToastsHost = (): JSX.Element => {
    const toasts = useSelector((state: RootState) => state.global.toasts);
    const dispatch = useDispatch();

    return <ToastsList toasts={toasts} onDismiss={(toast) => dispatch(removeToast(toast))} />;
};

export default ToastsHost;
